import { useEffect } from "react"

/**
 * This hooks hides the bottom navigation wherever its called
 * @usage useHideBottomNavigation()
 */
const useHideGlobalBottomNavigation = () => {
  useEffect(() => {
    document.body.classList.add("hideGlobalBottomNavigation")
    return () => {
      document.body.classList.remove("hideGlobalBottomNavigation")
    }
  }, [])
}

export default useHideGlobalBottomNavigation
